module.exports = __webpack_public_path__ + "img/apple-app-store_zh_equalised.bf75180c.svg";